// 口コミカードのデータを一元管理（居場所への口コミ用）
const reviewCards = [
  {
    id: 1,
    title: "とても居心地が良かったです",
    text: "スタッフの方が優しくて、安心して過ごせました。また来たいです。",
    body: "居場所に通い始めて数ヶ月が経ちましたが、ここでは自分のペースで過ごせるのがとても良いです。無理に話さなくても大丈夫だし、話したい時は聞いてもらえます。",
    tags: ['#居心地良い', '#スタッフ優しい'],
    authorName: "ゆうき",
    authorInitial: "Y",
    date: "2025.07.05",
    placeId: 1, // どの居場所への口コミか
    rating: 5
  },
  {
    id: 2,
    title: "友達ができました",
    text: "同じような経験をした人と出会えて、話せる場所ができて嬉しいです。",
    body: "最初は緊張していましたが、みんな優しくて少しずつ話せるようになりました。ここに来ると元気が出ます。",
    tags: ['#友達', '#交流'],
    authorName: "あいママ",
    authorInitial: "A",
    date: "2025.07.04",
    placeId: 1,
    rating: 5
  },
  {
    id: 3,
    title: "自分のペースで過ごせます",
    text: "無理に何かをさせられることがなく、読書したり絵を描いたり自由です。",
    body: "学校では周りに合わせなきゃいけなかったけど、ここでは自分らしくいられます。そんな場所があることに感謝しています。",
    tags: ['#自由', '#マイペース'],
    authorName: "さくら",
    authorInitial: "S",
    date: "2025.07.03",
    placeId: 2,
    rating: 4
  },
  {
    id: 4,
    title: "アクセスが良い",
    text: "駅から近くて通いやすいです。親も送り迎えしやすいと言っています。",
    body: "立地が良いので気軽に寄れるのが魅力です。学校帰りに少し立ち寄ることもできます。",
    tags: ['#アクセス', '#通いやすい'],
    authorName: "たけし父",
    authorInitial: "T",
    date: "2025.07.02",
    placeId: 2,
    rating: 4
  },
  {
    id: 5,
    title: "プログラムが充実",
    text: "工作やゲームなど、色々な活動ができて楽しいです。",
    body: "毎週違うプログラムがあって飽きません。特に料理教室が楽しかったです。",
    tags: ['#プログラム', '#活動'],
    authorName: "みゆき",
    authorInitial: "M",
    date: "2025.07.01",
    placeId: 3,
    rating: 5
  },
  {
    id: 6,
    title: "静かで落ち着く空間",
    text: "騒がしくないので、集中して勉強したり本を読んだりできます。",
    body: "図書コーナーが充実していて、好きな本を読めるのが嬉しいです。静かな環境が好きな人におすすめです。",
    tags: ['#静か', '#勉強'],
    authorName: "ひろママ",
    authorInitial: "H",
    date: "2025.06.30",
    placeId: 3,
    rating: 5
  }
];

export default reviewCards;
